import { render, staticRenderFns } from "./Statistic.vue?vue&type=template&id=17cb821b&scoped=true"
import script from "./Statistic.vue?vue&type=script&lang=js"
export * from "./Statistic.vue?vue&type=script&lang=js"
import style0 from "./Statistic.vue?vue&type=style&index=0&id=17cb821b&prod&scoped=true&lang=scss"
import style1 from "./Statistic.vue?vue&type=style&index=1&id=17cb821b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cb821b",
  null
  
)

export default component.exports